import React, { ReactElement } from 'react'
import { colors } from '../../const/theme'
import { RankCircleWrapper, Circle, Rank } from './subcomponents'

interface RankCircleProps {
  rank: number
  width?: number
  themeKey: 'performanceCard' | 'leaderBoard'
}

const RankCircle = ({
  rank = 0,
  width,
  themeKey
}: RankCircleProps): ReactElement => {
  return (
    <RankCircleWrapper width={width} themeKey={themeKey}>
      <Circle themeKey={themeKey}>
        <Rank color={colors.white}>{rank}</Rank>
      </Circle>
    </RankCircleWrapper>
  )
}

export default RankCircle
